

































































































































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import moment from "moment";
import MyList from "@/mixins/list";
// import MyForm from '@/mixins/form'

@Component
export default class extends Mixins(MyList) {
  dispatchType = "stadium/getEquipCameras";

  // @Prop() handleCancel!: (...args: any[]) => any;

  @Prop() stadiumId!: number;

  @Prop() mainEquip!: any;

  @Prop() mainEquipIdx!: number;

  @Prop() grounds!: any;

  groundOptions: any[] = [];
  videoOptions: any[] = [];

  equipInfo = {
    id: 0
  };

  addform1!: any;

  editform2!: any;

  addModalVisible1 = false;

  editModalVisible1 = false;

  addFormData: any = {
    stadium_id: this.stadiumId,
    position: "",
    channel_no: "",
    camera_status: "1",
    thumbnail: "",
    main_equipment_id: "",
    main_equipment_name: "",
    main_equipment_code: "",
    name: "",
    remark: "",
    note: "",
    permission: "0",
    stadium_ground_ids: [],
    equipment_video_id:"0"
  };

  editFormData: any = {
    stadium_id: this.stadiumId,
    id: "",
    position: "",
    channel_no: "",
    camera_status: "1",
    thumbnail: "",
    name: "",
    remark: "",
    note: "",
    permission: 0,
    stadium_ground_ids: [],
    equipment_video_id:"0"
  };

  columns: any[] = [
    { title: "标识", scopedSlots: { customRender: "equipment_main_id" } },
    { title: "位置描述", dataIndex: "position" },
    { title: "缩略图", dataIndex: "thumbnail" },
    { title: "摄像头状态", scopedSlots: { customRender: "camera_status" } },
    { title: "播放状态", dataIndex: "playing_status" },
    { title: "通道号", dataIndex: "channel_no" },
    { title: "摄像头名称", dataIndex: "name" },
    { title: "摄像头描述", dataIndex: "remark" },
    { title: "备注", dataIndex: "note" },
    { title: "馆长权限", scopedSlots: { customRender: "permission" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  created() {
    // console.log('')
    this.addform1 = this.$form.createForm(this);

    this.editform2 = this.$form.createForm(this);
  }

  mounted() {
    this.groundOptions = [];
    this.videoOptions=[];
    // console.log(this.grounds);

    for (const k in this.grounds) {
      const obj = this.grounds[k];
      if (obj.id > 0) {
        this.groundOptions.push({
          label: obj.name,
          value: String(obj.id)
        });
        this.mainEquip.filter((v:any,i:any)=>{
          if(v.stadium_ground_id!=obj.id || v.type !==8){
            return false
          }
          this.videoOptions.push({
            label:obj.name+"-"+v.name,
            value: String(v.id)
          })
        })
      }
    }
    const obj = this.mainEquip[this.mainEquipIdx];
    this.equipInfo = obj;

    // console.log(this.equipInfo);
    this.addFormData.equipment_main_name = obj.name;
    this.addFormData.equipment_main_id = obj.id;
    this.addFormData.equipment_main_code = obj.code;

    this.editFormData.equipment_main_name = obj.name;
    this.editFormData.equipment_main_id = obj.id;
    this.editFormData.equipment_main_code = obj.code;

    this.loadCameras();
  }

  loadCameras() {
    this.searchData.stadium_id = this.stadiumId;
    this.searchData.equipment_main_id = this.equipInfo.id;
    this.loadData1();
  }

  async loadData1() {
    this.loading = true;
    const res = await this.$store.dispatch(this.dispatchType, {
      ...this.searchData
    });
    if (res && res.Data) {
      this.data = res.Data;
    }
    this.loading = false;
  }

  showAdd() {
    if (this.editFormData.equipment_main_id) {
      this.addModalVisible1 = true;
    } else {
      this.$message.error("请先保存主设备");
    }
  }

  hideAdd() {
    this.addModalVisible1 = false;
  }

  async showEdit(id: number) {
    this.spinLoading = true;
    const res = await this.$store.dispatch("stadium/getEquipCamera", {
      id
    });

    if (res && res.Data) {
      this.editFormData.stadium_id = res.Data.stadium_id;
      this.editFormData.id = res.Data.id;
      this.editFormData.position = res.Data.position;
      this.editFormData.channel_no = res.Data.channel_no;
      this.editFormData.camera_status = res.Data.camera_status;
      this.editFormData.thumbnail = res.Data.thumbnail;
      this.editFormData.name = res.Data.name;
      this.editFormData.remark = res.Data.remark;
      this.editFormData.note = res.Data.note;
      this.editFormData.permission = res.Data.permission;
      this.editFormData.stadium_ground_ids = res.Data.stadium_ground_ids.split(",");
      this.editFormData.equipment_video_id = res.Data.equipment_video_id;
      // console.log(this.editFormData);
    }
    this.editModalVisible1 = true;
    this.spinLoading = false;
  }

  hideEdit() {
    this.editModalVisible1 = false;
  }

  handleDelete1(id: number) {
    this.showTsConfirm({
      title: "确认信息",
      content: "确定要删除吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/deleteEquipCamera", {
          id
        });
        if (res && res.Message && res.Message === "success") {
          this.loadCameras();
          this.$message.success("删除成功");
        } else {
          this.$message.error("删除失败");
        }
      }
    });
  }

  handleSubmit(name: string) {
    // console.log(name)
    if (name === "add") {
      this.addform1.validateFields((err: any, fieldValues: any) => {
        if (!err) {
          this.showTsConfirm({
            title: "确认信息",
            content: "你确定要提交吗？",
            onOk: async () => {
              const values: any = {};
              for (const key in fieldValues) {
                if (_.get(fieldValues, [key])) {
                  const fieldValue = _.get(fieldValues, [key]);
                  if (moment.isMoment(fieldValue)) {
                    _.set(values, [key], moment(fieldValue).format("YYYY-MM-DD HH:mm:ss"));
                  } else if (key === "stadium_ground_ids") {
                    _.set(values, [key], fieldValue.join(","));
                  } else {
                    _.set(values, [key], fieldValue);
                  }
                }
              }
              this.confirmLoading = true;
              const res = await this.$store.dispatch("stadium/addEquipCamera", {
                stadium_id: this.stadiumId,
                equipment_main_id: this.addFormData.equipment_main_id,
                equipment_main_name: this.addFormData.equipment_main_name,
                equipment_main_code: this.addFormData.equipment_main_code,
                ...values
              });
              //   console.log(res)
              if (res && res.Message === "success") {
                this.$message.success("添加成功");
                this.loadCameras();
                this.addModalVisible1 = false;
              } else {
                this.$message.error("添加失败");
              }
              this.confirmLoading = false;
            }
          });
        }
      });
    } else if (name === "edit") {
      this.editform2.validateFields((err: any, fieldValues: any) => {
        if (!err) {
          this.showTsConfirm({
            title: "确认信息",
            content: "你确定要提交吗？",
            onOk: async () => {
              const values: any = {};
              for (const key in fieldValues) {
                if (_.get(fieldValues, [key])) {
                  const fieldValue = _.get(fieldValues, [key]);
                  if (moment.isMoment(fieldValue)) {
                    _.set(values, [key], moment(fieldValue).format("YYYY-MM-DD HH:mm:ss"));
                  } else if (key === "stadium_ground_ids") {
                    _.set(values, [key], fieldValue.join(","));
                  } else {
                    _.set(values, [key], fieldValue);
                  }
                }
              }

              this.confirmLoading = true;
              const res = await this.$store.dispatch("stadium/editEquipCamera", {
                stadium_id: this.stadiumId,
                id: this.editFormData.id,
                equipment_main_id: this.editFormData.equipment_main_id,
                equipment_main_name: this.editFormData.equipment_main_name,
                equipment_main_code: this.editFormData.equipment_main_code,
                ...values
              });
              //   console.log(res)
              if (res && res.Message === "success") {
                this.$message.success("修改成功");
                this.loadCameras();
                this.editModalVisible1 = false;
              } else {
                this.$message.error("修改失败");
              }
              this.confirmLoading = false;
            }
          });
        }
      });
    }
  }
}
